import {
  ChakraBox,
  ChakraFlex,
  ChakraText,
  CircularProgress,
  EquipUIFireflyV2Theme,
  EquipUITheme,
  Files,
} from '@equip.health/ui';
import './reports.css';
import { useLazyGetUserReportLinkQuery } from '~/store/services/reports';

interface ReportListItemProps {
  description: string;
  name: string;
  reportId: string;
}
const { h6, label, labelBold } = EquipUITheme.typography;
const { primary, background } = EquipUIFireflyV2Theme.colors;

const ReportListItem = ({
  description,
  name,
  reportId,
}: ReportListItemProps) => {
  const TOP_LEVEL_ID = `report-list-item__${reportId}`;

  const [getReportLink, { isLoading: isGetReportLinkLoading }] =
    useLazyGetUserReportLinkQuery();

  const handleViewReport = () => {
    getReportLink(reportId).then((queryResult) => {
      if (queryResult?.data) {
        window.open(queryResult.data, '_blank', 'noopener');
      }
    });
  };

  return (
    <ChakraBox
      className="report-list-item"
      cursor="pointer"
      id={TOP_LEVEL_ID}
      onClick={handleViewReport}
      position="relative"
      sx={{ opacity: isGetReportLinkLoading ? '0.5' : 'none' }}
    >
      {isGetReportLinkLoading && (
        <CircularProgress
          isIndeterminate
          left="50%"
          position="absolute"
          size="30px"
          top="50%"
        />
      )}
      <ChakraText {...h6} id={`${TOP_LEVEL_ID}__name`} paddingBottom="8px">
        {name}
      </ChakraText>
      <ChakraText
        {...label}
        className="report-list-description"
        id={`${TOP_LEVEL_ID}__description`}
        title={description}
      >
        {description}
      </ChakraText>

      <ChakraFlex>
        <ChakraText
          color={background.button['primary.active']}
          {...labelBold}
          as="span"
          float="right"
          id={`${TOP_LEVEL_ID}__view-report-label`}
          marginLeft="auto"
          marginRight="6px"
        >
          View report
        </ChakraText>
        <Files fill={primary[100]} height="16px" width="16px" />
      </ChakraFlex>
    </ChakraBox>
  );
};

export default ReportListItem;
